import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'ROLE_DETAIL',
        create: 'ROLE_CREATE',
        update: 'ROLE_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'role_name',
        default: '',
        label: '角色名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.role_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "role_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'role_key',
        default: '',
        label: '权限字符',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.role_key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "role_key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'role_sort',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示顺序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.role_sort,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "role_sort", $$v);
              }
            }
          });
        }
      }, {
        prop: 'role_menu',
        default: '',
        label: '菜单权限',
        render: function render() {
          return h("d2-tree", {
            "attrs": {
              "source": "MENU_ALL",
              "key-label": "menu_name",
              "multiple": true,
              "half-mix": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.role_menu,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "role_menu", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};